import { derived, writable } from 'svelte/store';
import { produce } from 'immer';
export var ActionType = {
    setMainToTopInPx: 'setMainToTopInPx',
    setIsNavbarTransparent: 'setIsNavbarTransparent',
    toggleVideo: 'toggleVideo',
    toggleContact: 'toggleContact'
};
var DefaultValues = {
    View: {
        mainToTopInPx: null,
        isNavbarTransparent: true,
        videoOpen: false,
        contactOpen: false
    }
};
var RootReducer = function (state, type, payload) {
    return produce(state, function (draft) {
        switch (type) {
            case ActionType.setMainToTopInPx:
                draft.View.mainToTopInPx = payload;
                break;
            case ActionType.setIsNavbarTransparent:
                draft.View.isNavbarTransparent = payload;
                break;
            case ActionType.toggleVideo:
                draft.View.videoOpen = !state.View.videoOpen;
                break;
            case ActionType.toggleContact:
                draft.View.contactOpen = !state.View.contactOpen;
            default:
                break;
        }
    });
};
function initStore(defaultValues, rootReducer, middleware) {
    var WritableStore = writable(defaultValues);
    var subscribe = WritableStore.subscribe, update = WritableStore.update;
    var dispatch = function (dispatchObject) {
        return update(function (state) {
            middleware === null || middleware === void 0 ? void 0 : middleware(state, dispatchObject.type, dispatchObject.payload);
            return rootReducer(state, dispatchObject.type, dispatchObject.payload);
        });
    };
    return { subscribe: subscribe, dispatch: dispatch };
}
var singleton = initStore(DefaultValues, RootReducer);
export var store = derived(singleton, function ($singleton) { return $singleton; });
export var useDispatch = function () { return singleton.dispatch; };
